import React from 'react'
import {NavBar} from "../components/NavBar";
import {Footer} from "../components/Footer";

export const Layout = ({ children }) => {
    return (
        <>
            <NavBar/>
            <div>{children}</div>
            <Footer />
        </>
    );
}
